// start DES read more function

function waitForProductDes(selector, callback) {
  const el = document.querySelector(selector);
  if (el) {
    callback(el);
  } else {
    requestAnimationFrame(() => waitForProductDes(selector, callback));
  }
}

function insertAfter(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

waitForProductDes('.product-des', function(wrapper) {
  const btn = document.createElement('button');
  btn.textContent = 'Read more';
  btn.style.display = 'block';
  btn.style.margin = '20px auto';
  btn.style.padding = '10px 20px';
  btn.style.cursor = 'pointer';
  btn.style.backgroundColor = '#f39c12';
  btn.style.color = '#ffffff';
  btn.style.border = 'none';
  btn.style.borderRadius = '25px';

  wrapper.style.maxHeight = '400px';
  wrapper.style.overflow = 'hidden';
  wrapper.style.transition = 'max-height 0.5s ease';
  wrapper.style.position = 'relative';

  let expanded = false;

  btn.addEventListener('click', function() {
    if (expanded) {
      wrapper.style.maxHeight = '400px';
      btn.textContent = 'See more Options & Upgrades';
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
      btn.textContent = 'Read less';
    }
    expanded = !expanded;
  });

  insertAfter(btn, wrapper);
});
// end DES read more function

// start live chat function

        function allow_whitelist_countries() {
			
    // Whitelist countries
    const whitelist_countries = [
        //"IL", // Israel
        "US" // United States
    ]

    // Detecting the users country
    function get_country_code(api_url) {
        fetch(api_url, { method: 'GET' })
            .then(response => response.json()) // Getting ip info as json
            .then(result => {
                if (whitelist_countries.includes(result.country)) { // If my ip country code is not in whitelist
                    console.log("live chat run");
                    window.__lc = window.__lc || {};
                    window.__lc.license = 14158305;
                    window.__lc.integration_name = "manual_channels";
                    window.__lc.product_name = "livechat";
                    ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))
    
                }else{
                  console.log("live not chat run");
                }
            })
            .catch(error => console.log('error', error))
    }

    // Getting country code from third party api
    get_country_code("https://get.geojs.io/v1/ip/country.json")
}

/* -------------- */
/* CALL FUNCTIONS */
/* -------------- */
allow_whitelist_countries()

// end live chat function